module.exports = __webpack_public_path__ + "img/front-view.9d24e3d6.jpg";